<template>
  <div class="container-fluid m-0 p-0">
    <div class="welcomeBlock text-center p-3 mb-0" v-if="!loginUser">
      <h1>Tinkable 데이타 서비스에 오신 것을 환영합니다.</h1>
      <div class="lead mb-3 mt-3">Tinkable 데이터 서비스는 Tinkable IoT 키트 사용자를 위한 데이터 저장 서비스입니다.</div>
      <div>
        <b-button variant="primary" v-b-modal.loginFloat>Login</b-button>
      </div>
    </div>

    <div class="welcomeBlock text-center p-3 mb-0" v-else>
      <h1><span class="sunflower" style="font-size: 120%;">
        {{ loginUser.displayName }}</span>님 환영합니다.
      </h1>
      <div class="lead mb-3 mt-3">
        당신의 IoT 기기에서 나오는 데이터를 저장하고 다양한 방식으로 보세요.
      </div>
      <div style="line-height: 110%;">


        <router-link :to="{ name: 'tinkUser', params: { uid : loginUser.id }}" v-slot="{ navigate }">
          <b-button @click="navigate" @keypress.enter="navigate" role="link" variant="primary" class="mr-4 cursor-pointer">내 기기 목록 보기</b-button>
        </router-link>

        <router-link :to="{ name: 'tinkUser', params: { uid : loginUser.id }, query: { mode: 'add', action : 'addDevice' }}" v-slot="{ navigate }">
          <b-button @click="navigate" @keypress.enter="navigate" role="link" variant="primary" class="mr-4 cursor-pointer">기기 등록하기</b-button>
        </router-link>


    </div>
  </div>
  <div class="container-fluid m-0 p-0">
    <div class="welcomeBlock p-1 mp-3">
      <ul style="line-height: 180%;">
        <li>
          <b style="color: red">2021년 7월 8일 &alpha;에서 <big>&beta;</big>로 업그레이드</b> 하였습니다. 문제가 있으신 분은 메일로 연락주세요.
        </li>
        <li>
          Tinkable에 관심이 있으신 분은 <a href="mailto:data.tinkable@gmail.com">data.tinkable@gmail.com</a>으로 연락주시면 됩니다.
        </li>
      </ul>
    </div>
  </div>
  <b-card-group fluid deck class="m-2 mt-2 mb-0 text-center">

    <b-card class="m-1 p-0 shadow">
      <b-card-title class="font-weight-bold">팅커블 Data 서비스</b-card-title>
      <b-card-body class="p-1">
        <div class="p-1 border text-left bg-blue-lighter gothic fontSizeDot9">
          <p class="text-left m-1">
            Tinkable IoT 키트를 원격에서 관리하고, 측정한 데이터를 저장하고, 표와 그래프로 데이터를 분석하는 웹서비스(웹앱)
          </p>
          <ul style="list-style-type:square;" class="pl-4">
            <li>언제나 데이터는 실시간.
              <code><s><span class="border border-secondary">Ctrl</span>+R</s></code></li>
            <li>접속코드, MAC 주소로 쉽게 연결</li>
            <li>관리자, 친구 기능으로 편리한 공동작업</li>
            <li>기기의 기본/WiFi/센서 설정을 원격에서</li>
            <li>기기의 상태를 자세히 알려주는 리포트 기능</li>
            <li>기기의 현재 데이터를 구글 지도 위에 표시</li>
            <li>필터, 정렬, 그룹, 다운로드 등 강력한 데이터 표</li>
            <li>줌과 팬을 지원하고, 자유롭게 설정가능한 그래프</li>
          </ul>
        </div>
        <b-list-group class="mt-2">
          <b-list-group-item class="list-group-item mb-1 p-1 text-center">
            <router-link :to="{ name: 'tinkAboutData' }" custom v-slot="{ navigate }">
              <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                팅커블 Data서비스 소개
              </span>  
            </router-link>
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
    </b-card>

    <b-card class="m-1 p-0 shadow">
      <b-card-title class="font-weight-bold">
        팅커블 IoT 키트
      </b-card-title>
      <b-card-body class="p-1">
        <div class="pl-5 pr-5 pt-2 pb-2 border">
          <b-img src="https://storage.cloud.google.com/imgcdn.tinkable.net/www/v3.png" fluid-grow></b-img>
        </div>
        <div style="position:absolute; top: 5rem; left: 6rem; text-align: left; line-height: 200%; width: 50%;">
          <router-link :to="{ name: 'tinkAboutKit' }" style="color: yellow; background-color: rgba(0, 0, 0, 0.6); font-size: 1.1rem;  font-family: 'Sunflower', sans-serif;" custom v-slot="{ navigate }">
              <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                선없이! 납땜없이!<br/>
                현실 세계의 다양한 데이터를 수집하는<br/>
                팅커블IoT키트
              </span>  
          </router-link>
        </div>
        <b-list-group class="mt-3">
          <b-list-group-item class="list-group-item mb-1 p-1">
            <router-link :to="{ name: 'tinkAboutKit' }" custom v-slot="{ navigate }">
              <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                팅커블IoT키트 소개
              </span>  
            </router-link>
          </b-list-group-item>
          <b-list-group-item class="list-group-item mb-1 mt-1 p-1" target="_new">
            <b>&rarr;</b>
            <a href="https://www.tinkable.net" target="_new">
              Tinkable 블로그
            </a>
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
    </b-card>

    <b-card class="m-1 p-0 shadow">
      <b-card-title class="font-weight-bold">팅커블 Core 프로그램</b-card-title>
      <b-card-body class="p-1">
        <div style="font-size: 0.94rem; line-height: 120%;" class="text-left p-1 bg-secondary-lighter border-secondary-dark"><tt>
// <span style="color: white; background-color: rgba(0, 0, 0, 0.6);">프로그래밍 없이!</span><br/>
// <span style="color: white; background-color: rgba(0, 0, 0, 0.6);">바로 사용할 수 있게 해주는</span><br/>
// <span style="color: white; background-color: rgba(0, 0, 0, 0.6);">팅커블Core프로그램</span><br/>
<br/>
#include &lt;<b style="color: red;">Tinkable.h</b>&gt;<br/>
<br/>
void setup() {<br/>
&nbsp;&nbsp;tinkable.doSetup();<br/>
}<br/>
<br/>
void loop() {<br/>
&nbsp;&nbsp;tinkable.doLoop();<br/>
}</tt></div>
        <b-list-group class="mt-3">
          <b-list-group-item class="list-group-item mb-1 p-1">
            <router-link :to="{ name: 'tinkAboutCore' }" custom v-slot="{ navigate }">
              <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                팅커블Core프로그램 소개
              </span>  
            </router-link>
          </b-list-group-item>
        </b-list-group>
      </b-card-body>
    </b-card>
  </b-card-group>
</div>
</template>

<script>

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

import eventBus from "@/plugins/eventBus.js"

import { mapState } from "vuex"
import { mapSetter } from '@/plugins/vuexUtils.js'

export default {
  name: "tinkHome",
  data: function() {
      return {
        responseBody: ""
      }
  },
  computed: {
    ...mapSetter(
      mapState({
        loginUser: state => state.loginUser,
      })
    )
  }
}
</script>
<style scoped>
  .welcomeBlock { background-color : #e9ecef;}
</style>
